<template>
  <div class="animated fadeIn">
    <basic-heading title="New Work Group">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'add work group'">
      <template #gated-content>
        <work-group-form @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import WorkGroupForm from "@/components/lab/workgroup/WorkGroupForm";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { workGroupNotifications } from "@/shared/notifications";

const WorkGroupRepository = LabRepositoryFactory.get("workGroup");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "WorkGroupAdd",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    WorkGroupForm,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/workgroups",
            title: "Work Group list",
          },
        ],
      };
    },
  },
  methods: {
    async submit(payload) {
      try {
        const { data } = await WorkGroupRepository.create(payload);

        this.addSuccess();
        this.$router.push(`/workgroups/${data.id}`);
      } catch ({ response }) {
        const { message, error } = response.data;
        this.addFail({ message: message || error });
      }
    },
  },
  notifications: workGroupNotifications
};
</script>
